const normalizeUrl = (value: string) => value.replace(/\/+$/, "")
const runtimeConfig = import.meta.env.DEV ? undefined : globalThis.__TAKT_CONFIG__

export const config = Object.freeze({
    version: runtimeConfig?.version ?? "v0.0.0-dev",
    apiBaseUrl: normalizeUrl(
        runtimeConfig?.apiBaseUrl ?? import.meta.env.PUBLIC_API_BASE_URL ?? "https://api.takt.220191.xyz/v1",
    ),
    identityOrigin: normalizeUrl(
        runtimeConfig?.identityOrigin ??
            import.meta.env.PUBLIC_ID_ORIGIN ??
            (import.meta.env.DEV ? "http://localhost:5174" : "https://id.takt.220191.xyz"),
    ),
})

export const authBaseUrl = `${config.apiBaseUrl}/auth`
